import { combineReducers } from '@reduxjs/toolkit';
import { appReducer } from './ui/app/reducer';
import { loginReducer } from './ui/login/reducer';

export const uiReducer = combineReducers({
	app: appReducer,
	login: loginReducer,
});
